// Persistence for the selected UI language, stored in the shared `bao_settings`
// object alongside the other settings.

import { readSettingsObject, writeSetting } from "src/utils/baoSettingsStorage";

export function loadLanguage(): string | null {
  const settings = readSettingsObject();
  const language = settings?.language;
  return typeof language === "string" && language.length > 0 ? language : null;
}

export function saveLanguage(code: string): void {
  writeSetting("language", code);
}
